import { Typography, Box, Link } from '@evaneos/b2b-ui';
import { useIntl } from 'react-intl';
import { Link as ReactRouterLink } from 'react-router-dom';

import { useGetTrackedTripProperties, useTrackEventAmplitude } from '../../../../shared/analytics';

type ProcessingCompletedNotificationProps = {
    isSummaryOnly: boolean;
    dossierId: string;
    phoneCallId: number;
    onDismiss: () => void;
};

export const ProcessingCompletedNotification = ({
    isSummaryOnly,
    dossierId,
    phoneCallId,
    onDismiss,
}: ProcessingCompletedNotificationProps) => {
    const { formatMessage } = useIntl();
    const { trackEvent } = useTrackEventAmplitude();
    const trackedTripProperties = useGetTrackedTripProperties(dossierId);

    const transcriptUrl = `/dossier/${dossierId}/discussion?phoneCall=${phoneCallId}&fromNotification=true`;

    const titleMessageId = isSummaryOnly
        ? 'experiment.better_business.dossier.discussion.phone_call.notification.summary_ready'
        : 'experiment.better_business.dossier.discussion.phone_call.notification.transcript_ready';

    const linkMessageId = isSummaryOnly
        ? 'experiment.better_business.dossier.discussion.phone_call.notification.view_summary_link'
        : 'experiment.better_business.dossier.discussion.phone_call.notification.view_transcript_link';

    const onLinkClick = () => {
        trackEvent((ampli, defaultProperties) => {
            ampli.transcriptViewed({
                ...defaultProperties,
                ...trackedTripProperties,
                call_id: phoneCallId.toString(),
                synthesis_content: 'ok',
                click_source: 'toast',
            });
        });
        onDismiss();
    };

    return (
        <Box display="flex" flexDirection="column" gap={1}>
            <Typography
                sx={{ color: 'inherit', fontWeight: 700, fontFamily: 'inherit' }}
                variant="body2"
            >
                {formatMessage({ id: titleMessageId })}
            </Typography>
            <Link
                component={ReactRouterLink}
                to={transcriptUrl}
                onClick={onLinkClick}
                variant="body2"
                sx={{
                    color: 'inherit',
                    textDecoration: 'underline',
                    fontWeight: 'bold',
                    fontFamily: 'inherit',
                }}
            >
                {formatMessage({ id: linkMessageId })}
            </Link>
        </Box>
    );
};
